import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Backdrop, Box, Fade, IconButton, Modal, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { IValidationResult } from '../../../../services/ContentValidator/interfaces/validation.interface';
import { AnalysisModalPage } from '../../interfaces/analysisModalPage.type';
import { IErrorDetailsData } from '../../interfaces/detailsData.interface';
import ErrorDetails from '../ErrorDetails/ErrorDetails';
import ErrorList from '../ErrorList/ErrorList';
import useStyles from './styles';

interface IContentAnalysisModalProps {
  open: boolean;
  handleClose?: () => void;
  analysis: IValidationResult;
}

const ContentAnalysisModal: React.FC<IContentAnalysisModalProps> = ({
  open,
  handleClose,
  analysis,
}) => {
  const [selectedDetails, setSelectedDetails] = useState<IErrorDetailsData | undefined>();
  const [currentPage, setCurrentPage] = useState<AnalysisModalPage>('list');

  const classes = useStyles();

  useEffect(() => {
    if (open) setCurrentPage('list');
  }, [open]);

  const onOpenDetails = (details: IErrorDetailsData) => {
    setSelectedDetails(details);
    setCurrentPage('details');
  };

  const handleBack = () => {
    setCurrentPage('list');
  };

  const getTitle = () => {
    const binds = {
      list: 'Content Analysis',
      details: 'Error Details',
    };

    return binds[currentPage] || '';
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      closeAfterTransition
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        className: classes.backdrop,
      }}
    >
      <Fade in={open}>
        <Box className={classes.modalPaper}>
          <Box className={classes.modalHeader}>
            <Box className={classes.modalHeaderSides}>
              { currentPage !== 'list' && (
                <IconButton onClick={handleBack}>
                  <FontAwesomeIcon icon="arrow-left" className={classes.modalHeaderBack} />
                </IconButton>
              )}
            </Box>
            <Box className={classes.modalHeaderCenter}>
              <Typography variant="h3" align="center">{getTitle()}</Typography>
            </Box>
            <Box className={clsx(classes.modalHeaderSides, classes.modalHeaderClose)}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {
            currentPage === 'list' ? (
              <ErrorList
                analysis={analysis}
                onOpenDetails={onOpenDetails}
              />
            ) : currentPage === 'details' ? (
              <ErrorDetails
                errorDetails={selectedDetails?.details || []}
                descriptionMessage={selectedDetails?.message || ''}
              />
            ) : <></>
          }
        </Box>
      </Fade>
    </Modal>
  );
};

export default ContentAnalysisModal;
